// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__1azz1","loading":"Spinner_loading__kNv1B","spin":"Spinner_spin__1RYg1"};